module.exports = __webpack_public_path__ + "static/media/app_bg.a0add0b1.jpg";